export function toDateString(date: Date) {
  return [date.getFullYear(), date.getMonth() + 1, date.getDate()]
    .map((n) => `${n}`.padStart(2, "0"))
    .join("-");
}

export function toUTCDateString(date: Date) {
  return [date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate()]
    .map((n) => `${n}`.padStart(2, "0"))
    .join("-");
}

export function asDate(val: unknown): Date | undefined {
  if (val == null) return undefined;
  if (val instanceof Date) return val;
  // ISO strings (JSON/Storage round-trip) and epoch millis.
  if (typeof val === "string" || typeof val === "number") {
    const parsed = new Date(val);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }
  if (typeof val === "object") {
    const o = val as {
      toDate?: () => Date;
      seconds?: number;
      _seconds?: number;
      nanoseconds?: number;
      _nanoseconds?: number;
    };
    if (typeof o.toDate === "function") return o.toDate();
    const seconds = o.seconds ?? o._seconds;
    if (typeof seconds !== "number") return undefined;
    const nanoseconds = o.nanoseconds ?? o._nanoseconds ?? 0;
    return new Date(seconds * 1000 + nanoseconds / 1e6);
  }
  return undefined;
}

/**
 * Sets a date to end-of-day (23:59:59.999).
 *
 * @param date - The date to modify
 * @param utcOffset - UTC offset in hours. If provided, sets end-of-day
 *   at that offset (0 = UTC). If omitted, uses local time.
 */
export function setEndOfDay(date: Date, utcOffset?: number): Date {
  if (utcOffset != null) {
    date.setUTCHours(23, 59, 59, 999);
    date.setTime(date.getTime() - utcOffset * 60 * 60 * 1000);
  } else {
    date.setHours(23, 59, 59, 999);
  }
  return date;
}
